import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Ribbon from '../../../core/common/ribbon/ribbon';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import { useSelector } from 'react-redux';
import Select, { StylesConfig } from "react-select";
import ActionWizard from '../Projects/ActionWizard/ActionWizard';
import { useGetWizardActionsQuery, useGetWizardTabsQuery, useLazyGetWizardActionsQuery, useLazyGetWizardTabsQuery } from '../../../services/EndPointsApis';
import { options1 } from '../../../core/common/selectoption/selectoption';
import UserInfoCard from '../Projects/User Info Card/UserInfoCard';
import { usePermission } from '../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../Config/Constants';

const ProjectTabsPages = ({ toggleInfoCard, setToggleInfoCard, setRefetchApiAfterWizard, refetchClientView, projectId, getallActiveUsers, refetchProject, projectByIdData, projectLookups, projectRecordNumber }: any) => {
    const storeProjectId: string | null = localStorage.getItem('projectId');
    const [actions, setActions] = useState('')

    //Permission Hook 
    const { view: viewJobInfo, edit: editJobInfo, create: createJobInfo } = usePermission(constantsPermission?.moduleId?.jonInfo);
    const { view: viewAssing, edit: editAssig, create: createAssig } = usePermission(constantsPermission?.moduleId?.assignments);
    const { view: viewOpportunity, edit: editOpportunity, create: createOpportunity } = usePermission(constantsPermission?.moduleId?.opportuityDetails);
    const { view: viewClientVisits, edit: editClientVisits, create: createClientVisits } = usePermission(constantsPermission?.moduleId?.clientVisit);
    const { view: viewNotes, edit: editNotes, create: createNotes } = usePermission(constantsPermission?.moduleId?.notes);
    const { view: viewDocuments, edit: editDocuments, create: createDocuments } = usePermission(constantsPermission?.moduleId?.documents);
    const { view: viewTasks, edit: editTask, create: createTask } = usePermission(constantsPermission?.moduleId?.task);
    const { view: viewJobScope, edit: editJobScope, create: createJobScope } = usePermission(constantsPermission?.moduleId?.jobScope);
    const { view: viewAddenda, edit: editAddenda, create: createAddenda } = usePermission(constantsPermission?.moduleId?.addenda);
    const { view: viewFunding, edit: editFunding, create: createFunding } = usePermission(constantsPermission?.moduleId?.funding);
    const { view: viewContigencies, edit: editContigencies, create: createContigencies } = usePermission(constantsPermission?.moduleId?.contigencies);
    const { view: viewSpecificationException, edit: editSpecificationException, create: createSpecifiationException } = usePermission(constantsPermission?.moduleId?.specificationException);
    const { view: viewDocumentPermission, edit: editDocumentPermission, create: createDocumentPermission } = usePermission(constantsPermission?.moduleId?.documentPermission);
    const { view: viewSaleInfo, edit: editSaleInfo, create: createSaleInfo } = usePermission(constantsPermission?.moduleId?.saleInfo);
    const { view: viewFinancial, edit: editFinancial, create: createFinancial } = usePermission(constantsPermission?.moduleId?.financial);
    const { view: viewPrintOuts, edit: editPrintOuts, create: createPrintOuts } = usePermission(constantsPermission?.moduleId?.printOuts);
    const { view: viewPermitZonning, edit: editPermitZonning, create: createPermitZonning } = usePermission(constantsPermission?.moduleId?.permitZoning);
    const { view: viewPropertyResource, edit: editPropertyResource, create: createPropertyResource } = usePermission(constantsPermission?.moduleId?.propertyResource);
    const { view: viewActionWizards, edit: editActionWizards, create: createActionWizards } = usePermission(constantsPermission?.moduleId?.actionWizards);


    const location = useLocation();
    const navigate = useNavigate();

    //GetWizardAction Api
    const [trigger, { data: wizardTabs }] = useLazyGetWizardTabsQuery()
    const { data: wizardActions, refetch: refetchWizardActions } = useGetWizardActionsQuery({ Id: storeProjectId })

    const viewOnly = location.pathname.includes(`view-project`);

    // List of all project-related tabs for dynamic rendering
    const tabs = [
        // { name: 'Details', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/details/${storeProjectId}` },
        { name: 'Job Info', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/details/${storeProjectId}`, hide: viewJobInfo },
        // { name: 'Contacts', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/contact/${storeProjectId}` },
        { name: 'Opportunity Details', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/opportunities/${storeProjectId}`, hide: viewOpportunity },
        // { name: 'Appointment', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/appointment/${storeProjectId}` },
        { name: 'Assignments', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/assignments/${storeProjectId}`, hide: viewAssing },
        { name: 'Task', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/task/${storeProjectId}`, hide: viewTasks },
        { name: 'Client Visits', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/client/${storeProjectId}`, hide: viewClientVisits },
        { name: 'Notes', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/notes/${storeProjectId}`, hide: viewNotes },
        { name: 'Documents', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/documents/${storeProjectId}`, hide: viewDocuments },
        { name: 'Lock', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/documentPermission/${storeProjectId}`, hide: viewDocumentPermission },
        // { name: 'Meetings', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/meetings/${storeProjectId}` },
        { name: 'Job Scope', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/job-scope/${storeProjectId}`, hide: viewJobScope },
        { name: 'Addenda', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/addenda/${storeProjectId}`, hide: viewAddenda },
        { name: 'Funding', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/funding/${storeProjectId}`, hide: viewFunding },
        { name: 'Contingencies', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/contigencies/${storeProjectId}`, hide: viewContigencies },
        { name: 'Specification Exceptions', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/specificationException/${storeProjectId}`, hide: viewSpecificationException },
        { name: 'Sale Info', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/saleInfo/${storeProjectId}`, hide: viewSaleInfo },
        { name: 'Financial', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/financial/${storeProjectId}`, hide: viewFinancial },
        { name: 'Printouts', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/printouts/${storeProjectId}`, hide: viewPrintOuts },
        { name: 'Permits & Zoning', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/permit&Zoning/${storeProjectId}`, hide: viewPermitZonning },
        { name: 'Property Resources', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/propertyResource/${storeProjectId}`, hide: viewPropertyResource },
        { name: 'Templates', path: `/projects/${viewOnly ? 'view-project' : 'editProject'}/templates/${storeProjectId}`, hide: viewPropertyResource },
    ];

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 })
    };
    const [toggleWizard, setToggleWizard] = useState(false);

    const handleShowstepper = () => {
        setToggleWizard(true);
    };
    const handlecloseWizard = () => {
        setToggleWizard(false);
    };



    return (
        <>
            <ActionWizard storeProjectId={storeProjectId} projectLookups={projectLookups} togglestepperAssignment={toggleWizard}
                closestepper={handlecloseWizard} wizardTabs={wizardTabs} actions={actions} getallActiveUsers={getallActiveUsers} projectRecordNumber={projectRecordNumber}
                refetchProject={refetchProject} refetchWizardActions={refetchWizardActions} setActions={setActions} refetchClientView={refetchClientView} setRefetchApiAfterWizard={setRefetchApiAfterWizard} />
            <div className="row">
                <div className="col-md-12">
                    <div className='card'>
                        <div className="card-body p-2 card-css overflowX-auto">
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                <div>
                                    <h4 className="color-red">{projectId}</h4>
                                    {/* <p>Renovation of House no. 188</p> */}
                                </div>
                                <div className='d-flex justify-content-end gap-3'>
                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                    <div>
                                        <b> {projectByIdData?.result?.projectStatus || '....'}</b>
                                        <p>Project Status</p>
                                    </div>
                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                    <div>
                                        <Link to={`/contacts/ViewContacts/${projectByIdData?.result?.contactId}`} className='color-red'> {projectByIdData?.result?.contactNo || '....'}</Link>
                                        <p>Contact No.</p>
                                    </div>
                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                    <div>
                                        <b> {projectByIdData?.result?.contactName || '....'}</b>
                                        <p>Primary Contact</p>
                                    </div>
                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                    <div>
                                        <b> {projectByIdData?.result?.pdm || '....'}</b>
                                        <p>PDM</p>
                                    </div>
                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                    {viewActionWizards &&
                                        <>
                                            <div className='d-flex align-items-center gap-2'><p className='mb-0'>Actions:</p>
                                                <Select
                                                    styles={customStyles}
                                                    menuPortalTarget={document.body}
                                                    className="select select-width"
                                                    options={wizardActions?.result?.map((option: any) => ({
                                                        label: option?.value,
                                                        value: option?.id
                                                    })) || []}
                                                    value={actions}
                                                    onChange={(selectedOption: any) => {
                                                        setActions(selectedOption)
                                                        trigger({ Id: selectedOption.value })
                                                    }}
                                                />
                                                <button className="btn btn-primary ps-3 pe-3 px-3 py-2"
                                                    onClick={handleShowstepper}
                                                    disabled={!actions}
                                                >Go</button>
                                            </div>

                                        </>
                                    }
                                    {/* <button className="btn btn-primary ps-3 pe-3"
                                        onClick={handleShowInfoCard}
                                    >
                                            <i className="fa-solid fs-16 fa-address-book"></i>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className="card-body p-2 card-css">
                            <div>
                                <ul className='nav nav-stretch nav-line-tabs project-tabs p-0'>
                                    {tabs.map((tab, index) => {
                                        return (
                                            <>
                                                {tab.hide &&
                                                    <li className='nav-item' key={index}>
                                                        <Link
                                                            className={
                                                                `nav-link text-active-primary me-6 mb-2 ` +
                                                                (location.pathname === tab.path && 'active')
                                                            }
                                                            to={tab.path}
                                                        >
                                                            {tab.name}
                                                        </Link>
                                                    </li>
                                                }
                                            </>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProjectTabsPages;
